import { TAVAILABILITY_TYPE, TMECHANIC_LOGIN_ACTIVITY } from '@monorepo/types';
import { TAccordionTableVM } from '../../model/accordion-table.types';
import { TICKET_LIST_HELPER } from './ticket-list-helper';
import * as _ from 'lodash';
import { ACCORDION_TABLE_MODIFIER } from '../../model/accordion-table.modifier';

type AVAILABILITY_CONFIG = {
  displayName: string;
  className: string;
};

const AVAILABILITY_COLOR_CONF: Record<TAVAILABILITY_TYPE, AVAILABILITY_CONFIG> = {
  AVAILABLE: { displayName: 'Available', className: 'accordian-table__tag--green' },
  BUSY: { displayName: 'Busy', className: 'accordian-table__tag--red' },
  WAITING_FOR_APPROVAL: { displayName: 'Waiting for Approval', className: 'accordian-table__tag--blue' },
};

export const MECHANIC_DASHBOARD_ACCORDION_TABLE_MODEL = {
  createModel(mechanics: TMECHANIC_LOGIN_ACTIVITY[]): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.createModel(
      [
        { label: 'Name', colSize: 10 },
        { label: 'ID', colSize: 8 },
        { label: 'Availablity', colSize: 5 },
      ],
      mechanics.map((mechanic) => {
        return {
          id: mechanic.employeeDetailsAndContact.employeeId,
          tag: _.compact([
            mechanic.availabilityOpt
              ? {
                  displayName: AVAILABILITY_COLOR_CONF[mechanic.availabilityOpt].displayName,
                  frequency: 1,
                  class: AVAILABILITY_COLOR_CONF[mechanic.availabilityOpt].className,
                }
              : undefined,
          ]),
          isMinimized: true,
          rowItems: [
            {
              type: 'TEXT',
              value: mechanic.employeeDetailsAndContact.name,
            },
            { type: 'TEXT', value: mechanic.employeeDetailsAndContact.employeeId },
            mechanic.currentLoginStatus
              ? {
                  type: 'STATUS' as const,
                  displayName: mechanic.currentLoginStatus.isLoggedIn ? 'Online' : 'Offline',
                  color: mechanic.currentLoginStatus.isLoggedIn ? ('#0e8526' as const) : ('#db3f27' as const),
                }
              : {
                  type: 'TEXT' as const,
                  value: '--',
                },
          ],
          moreInfo: [
            {
              items: [
                {
                  size: 12,
                  label: 'Name',
                  values: TICKET_LIST_HELPER.mapToValuesList([mechanic.employeeDetailsAndContact.name]),
                },
                {
                  size: 12,
                  label: 'Availability',
                  values: mechanic.availabilityOpt
                    ? TICKET_LIST_HELPER.mapToValuesList([mechanic.availabilityOpt])
                    : [],
                },
                {
                  size: 12,
                  label: mechanic.currentLoginStatus?.isLoggedIn ? 'Log on time' : 'Log off time',
                  values: mechanic.currentLoginStatus?.lastActivityTime
                    ? TICKET_LIST_HELPER.mapToValuesList([
                        TICKET_LIST_HELPER.formatTimeStamp(mechanic.currentLoginStatus.lastActivityTime),
                      ])
                    : [],
                },
                {
                  size: 12,
                  label: 'Email ID',
                  values: mechanic.employeeDetailsAndContact.emailId
                    ? TICKET_LIST_HELPER.mapToValuesList([mechanic.employeeDetailsAndContact.emailId])
                    : [],
                },
                {
                  size: 12,
                  label: 'Contact Number',
                  values: mechanic.employeeDetailsAndContact.contactNumber
                    ? TICKET_LIST_HELPER.mapToValuesList([mechanic.employeeDetailsAndContact.contactNumber])
                    : [],
                },
              ],
            },
          ],
          actions: [],
        };
      }),
    );
  },
};
